export const PDF_PRINT_VERSION = {
  V1: 'v1',
  V2: 'v2',
  MULTI: 'multi',
};

/**
 * The "multi" variant is intentionally disabled in any of the
 * MULTI_BLOCKED_ENVIRONMENTS. If LaunchDarkly serves "multi"
 * in one of these environments, we coerce to v1.
 */
const MULTI_BLOCKED_ENVIRONMENTS = new Set(['production', 'prod']);

const getRuntimeEnvironment = () => {
  return (process.env.REACT_APP_ENVIRONMENT || '').trim().toLowerCase();
};

const isMultiBlockedEnvironment = () => {
  const runtimeEnvironment = getRuntimeEnvironment();
  return MULTI_BLOCKED_ENVIRONMENTS.has(runtimeEnvironment);
};

/**
 * LaunchDarkly React SDK camel-cases flag keys by default, but we also support
 * the raw key to avoid surprises if that config changes.
 *
 * Safety rail: the "multi" variant is intentionally disabled in any of the
 * MULTI_BLOCKED_ENVIRONMENTS. If LaunchDarkly serves "multi" in one of these
 * environments, we coerce to v1.
 */
export const getPdfPrintVersion = (flags) => {
  const rawValue = flags?.pdfPrintVersion ?? flags?.['pdf-print-version'];
  const normalizedValue =
    typeof rawValue === 'string' ? rawValue.trim().toLowerCase() : '';

  if (!Object.values(PDF_PRINT_VERSION).includes(normalizedValue)) {
    return PDF_PRINT_VERSION.V1;
  }

  if (
    normalizedValue === PDF_PRINT_VERSION.MULTI &&
    isMultiBlockedEnvironment()
  ) {
    return PDF_PRINT_VERSION.V1;
  }

  return normalizedValue;
};

export const getPdfPrintVisibility = (flags) => {
  const version = getPdfPrintVersion(flags);
  const showV1Pdf =
    version === PDF_PRINT_VERSION.V1 || version === PDF_PRINT_VERSION.MULTI;
  const showV2Pdf =
    version === PDF_PRINT_VERSION.V2 || version === PDF_PRINT_VERSION.MULTI;

  return {version, showV1Pdf, showV2Pdf};
};
